import { render, staticRenderFns } from "./FormulaireDonP2P.vue?vue&type=template&id=e556be5c"
import script from "./FormulaireDonP2P.vue?vue&type=script&lang=js"
export * from "./FormulaireDonP2P.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports